import { PartialRecursive } from '@bridebook/models/source/abstract/_';
import { IBucket } from '@bridebook/models/source/models/Countries/Buckets.types';

const result: PartialRecursive<IBucket['settings']> = {
  quickFiltersPill: {
    venue: ['exclusiveUse', 'lateAvailability'],
    photo: ['videographyAvailable'],
    music: ['dj', 'ensembleGroup', 'soloMusician'],
    catering: ['staffProvided', 'tablewareProvided'],
  },
  searchPresets: true,
  mandatoryOnboardingPhoneNumber: true,
  smartEmails: true,
  searchFilters: {
    venue: {
      venueType: [
        'countryHouseManorHouse',
        'barn',
        'castle',
        'hotel',
        'uniqueVenueType',
        'pubRestaurant',
        'cruiseBoatYacht',
        'conferenceCentre',
        'placeOfWorship',
        'townHallRegistryOffice',
        'rooftop',
        'winery',
      ],
    },
  },
};

export default result;
